var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box-container"},[_c('d-header',{class:{
      'pt-5': _vm.$laravel.user.is_owner_contact || _vm.$laravel.user.owner_id,
    },attrs:{"actions":[
      {
        label: _vm.$t('new_owner_business'),
        resource: 'ownerBusiness',
        path: 'owner-businesses/create',
        primary: true,
        color: 'is-primary',
      },
    ],"fluid":"","breadcrumbs":false}},[_c('h2',{staticClass:"title is-4"},[_vm._v("\n      "+_vm._s(_vm.$t("owner_businesses"))+"\n    ")])]),_vm._v(" "),_c('v-owner-business-list',{attrs:{"owner_id":_vm.model.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }